import { createSlice } from '@reduxjs/toolkit';

const initialMapPadding = { top: 84, left: 75 };
const initialBounds = [-97.316895, 31.914868, -71.630859, 49.425267];

const initialState = {
  viewState: {
    bounds: initialBounds,
    fitBoundsOptions: {
      padding: initialMapPadding,
    },
  },
  showCountyOverride: false,
  currentLocation: {
    state: null,
    name: null,
    id: null,
    geometry: null,
  },
  currentStation: {
    name: null,
    sid: null,
    lat: null,
    lng: null,
    state: null
  }
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    updateViewState(state, action) {
      state.viewState = action.payload;
    },
    changeShowCountyOverride(state, action) {
      state.showCountyOverride = action.payload;
    },
    changeLocation(state, action) {
      state.currentLocation = action.payload;
      state.currentStation = {
        name: null,
        sid: null,
        lat: null,
        lng: null,
        state: null
      };
    },
    changeStation(state, action) {
      state.currentStation = action.payload;
    }
  },
});

export const { updateViewState, changeShowCountyOverride, changeLocation, changeStation } =
  mapSlice.actions;
export default mapSlice.reducer;
